import { PageContainer } from "../components/pageContainer/PageContainer"
import OurProjectsBan from '.././assets/img/our-projects.jpg'
import { Banner } from "../components/banner/Banner"
import { Header } from "../components/header/Header"
import { OurProjectsSection } from "../layout/ourProjectsSection/OurProjectsSection"
import { useEffect } from "react"

export const OurProjects = () => {

    useEffect(() => {
        window.scroll(0,0);
    }, [])
    
    return (
        <PageContainer>
            <Banner img={OurProjectsBan} />
            <Header>Our Projects</Header>
            <OurProjectsSection />
        </PageContainer>
    )
}